import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import DefaultInitiateProposalPageStore, {
  DEFAULT_PROPOSAL_EXPERIENCES,
  DefaultInitiateProposalPageStoreContext,
  useDefaultInitiateProposalPageStore,
} from 'store/pages/initiate-quote/default/pageStore';
import DefaultInitiateProposalForm from 'components/initiate-quote/Default';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    proposalExperience,
    getInitialData,
  } = useDefaultInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <DefaultInitiateProposalForm key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={DEFAULT_PROPOSAL_EXPERIENCES}
        />,
        proposalExperience === 'FAVORITE' && (
          <FavoriteQuoteStep key="2" favoriteProposalStepController={favoriteProposalStepController} />
        ),
      ].filter(Boolean)}
    />
  );
});

const DefaultInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new DefaultInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <DefaultInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DefaultInitiateProposalPageStoreContext.Provider>
  );
};

export default DefaultInitiateProposalPage;
